/**
 * commons-core wraps a validation failure in a generic 400 whose REAL reason is
 * appended to `code` after this fixed prefix; `message` and `details` are
 * boilerplate and must never be shown to a user.
 *
 * Shared, because more than one service uses this envelope: property-service
 * (DV-2550, PMS status changes) and asset-service (DV-2851, photoset
 * provisioning). Lives here rather than being copied so the prefix has one
 * definition.
 */
export const VALIDATION_CODE_PREFIX =
  'EE:_COMMONS_CORE:UNHANDLED_VALIDATION_EXCEPTION:';

interface ValidationErrorLike {
  data?: { code?: unknown };
}

/** Strip the literal prefix (never split on the last colon — messages contain colons). */
export const extractValidationMessage = (error: unknown): string | null => {
  const code =
    error !== null && typeof error === 'object'
      ? (error as ValidationErrorLike).data?.code
      : undefined;
  if (typeof code !== 'string' || !code.startsWith(VALIDATION_CODE_PREFIX)) return null;
  const message = code.slice(VALIDATION_CODE_PREFIX.length).trim();
  return message.length > 0 ? message : null;
};
